import React from "react";
import "./ContentContainer.css";
import SectionTitle from "../sectionTitle/SectionTitle.js";
import SectionComicAppearances from "../comicAppearancesArea/SectionComicAppearances.js";
import SectionFeaturedComic from "../featuredComicArea/SectionFeaturedComic.js";
import VideoArea from "../videoArchiveArea/VideoAreaContainer.js";


var ContentContainer = class ContentContainer extends React.Component{
    componentDidMount (){
        window.scrollTo(0, 0);
    }

    render() {
      const inlineStyle = {
        marginBottom:"10px"
    }



      return (
        <div className="contentContainer">

            <div className="content_box_square" id="featuredAppearanceArea"    style={inlineStyle}>
                <SectionTitle title = {'Featured Appearance'} margin = {"6px 0 0 6px"}/>
                <SectionFeaturedComic  
                    featuredComics = {this.props.featuredComics}
                    changeFeaturedComics = {this.props.changeFeaturedComics}
                    characterInfo = {this.props.characterInfo}
                    changeRelatedCharacters = {this.props.changeRelatedCharacters}
                    showFeaturedArea = {this.props.showFeaturedArea}
                    showComicArea = {this.props.showComicArea}
                    changeMainComic = {this.props.changeMainComic }
                    changeCharacter = {this.props.changeCharacter}
                    showCharacterPopup = {this.props.showCharacterPopup}
                />
            </div>

            <div className="content_box_square" id="comicAppearancesArea" style={inlineStyle}>
                <SectionTitle title = {'Comic Appearances'} margin = {"6px 0 0 6px"}/>
                <SectionComicAppearances
                     characterInfo = {this.props.characterInfo}
                     showComicArea = {this.props.showComicArea}
                     changeMainComic = {this.props.changeMainComic }
                /> 
            </div>

            <div className="content_box_square" id="videoArchiveArea" style={inlineStyle}>
                <SectionTitle title = {'Video Archive'} margin = {"6px 0 0 6px"}/>
                <VideoArea 
                    characterInfo = {this.props.characterInfo}
                    videoInfo = {this.props.videoInfo}
                    showVideos = {this.props.showVideos}
                    changeVideos = {this.props.changeVideos}
                    changeSelectedVideo = {this.props.changeSelectedVideo}
                    changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
                />
            </div>
        </div>
      );
    }
  }

  export default ContentContainer;


// WEBPACK FOOTER //
// ./src/components/contentArea/ContentContainer.js